import {AppointmentFieldModel} from "#FrontEnd/AppointmentField.Model";

export {AppointmentFieldModel} from "./AppointmentField.Model";
import './AppointmentField';
import './AppointmentFieldCalendar';
import './AppointmentTimePicker';
import './Index.css';
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wpforms-field-appointment').forEach((element) => {
        let fieldId=element.getAttribute('data-field-id');

        let optionsInput=(element.querySelector('.fieldOptions') as HTMLInputElement) as HTMLInputElement;
        if(optionsInput!=null) {
            let options = JSON.parse(optionsInput.value);
            new AppointmentFieldModel(fieldId,options,element.closest('form').getAttribute('data-formid')).Render();
        }


    });
});